export default function _physicsProfiles() {
    /**
     * Main wrapper selector
     * @type {string}
     */
    const PHYSICS_LANDING = '.physics';
    /**
     * Individual card selector
     * @type {string}
     */
    const PROFILE_CARD = '[data-profile-category]';
    /**
     * Category container element
     * @type {string}
     */
    const CATEGORY_ELEMENT = '.physics-profiles__profile__category';
    /**
     * Category header element
     * @type {string}
     */
    const CATEGORY_HEADER = '.physics-profiles__profile__category--header';
    /**
     * Profile detail parent selector
     * @type {string}
     */
    const HIDE_ELEMENT = '[data-hide-element]';
    /**
     * Profile detail selector
     * @type {string}
     */
    const PROFILE_DETAIL = '[data-detail]';

    function initialisePhysicsProfiles() {
        const categoryType = document.querySelectorAll(CATEGORY_ELEMENT);

        const hideEmptyDetails = () => {
            const profileDetailParent = document.querySelectorAll(HIDE_ELEMENT);
            profileDetailParent.forEach((parent) => {
                const detail = parent.querySelector(PROFILE_DETAIL);
                if (detail.innerHTML === '') {
                    parent.remove();
                }
            });
        };

        const catagoriseCards = () => {
            categoryType.forEach((category) => {
                const categoryHeader =
                    category.querySelectorAll(CATEGORY_HEADER);
                const profileCards = category.querySelectorAll(PROFILE_CARD);

                categoryHeader.forEach((header) => {
                    profileCards.forEach((card) => {
                        const cardStyle = card.style;
                        // eslint-disable-next-line no-unused-expressions
                        card.dataset.profileCategory.includes(
                            header.dataset.category
                        )
                            ? (cardStyle.display = 'flex')
                            : card.remove();
                    });
                });
                hideEmptyDetails();
            });
        };

        catagoriseCards();
    }

    const pageExists = !!document.querySelector(PHYSICS_LANDING);
    // If the module exists, do whatever we need to
    if (pageExists) {
        initialisePhysicsProfiles();
    }
}

_physicsProfiles();
